import axios from "axios";
import React, { useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { useMutation } from "react-query";
import { useLocation, useNavigate } from "react-router-dom";
const ProfileCom = () => {
  const {
    control,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const { state } = useLocation();

  const navigate = useNavigate();

  const details = localStorage.getItem("companyDetails");
  const companyDetails = details ? JSON.parse(details) : null;

  // SETVALUE FOR COMPANY DETAILS

  useEffect(() => {
    if (companyDetails) {
      setValue("customerName", companyDetails?.customerName || null);
      setValue("shopName", companyDetails?.shopName || null);
      setValue("customerPhno", companyDetails?.customerPhno || null);
      setValue(
        "customeralternativePhno",
        companyDetails?.customeralternativePhno || null
      );
      setValue("companyAddress", companyDetails?.companyAddress || null);
      // setValue("companyLogo", companyDetails?.companyLogo || null);
      setValue("companyLocation", companyDetails?.companyLocation || null);
      setValue("companyPincode", companyDetails?.companyPincode || null);
      setValue("companyType", companyDetails?.companyType || null);
      setValue("emailId", companyDetails?.emailId || null);
      setValue("website", companyDetails?.website || null);
      setValue("gstNumber", companyDetails?.gstNumber || null);
      setValue("role", companyDetails?.role || null);
      setValue("password", companyDetails?.password || null);
      setValue("confirmpassword", companyDetails?.confirmpassword || null);
      setValue("gstNo", companyDetails?.gstNo || null);
      setValue("customerLevel", companyDetails?.customerLevel || null);
      setValue("lineRoute", companyDetails?.lineRoute || null);
      setValue("phoneNumber", companyDetails?.phoneNumber || null);
      setValue("status", companyDetails?.status || null);
      setValue("headoffice", companyDetails?.headoffice || null);
      setValue("district", companyDetails?.district || null);
      setValue("aCHolderName", companyDetails?.aCHolderName || null);
      setValue("bankName", companyDetails?.bankName || null);
      setValue("accountNumber", companyDetails?.accountNumber || null);
      setValue("ifscCode", companyDetails?.ifscCode || null);
      setValue("branch", companyDetails?.branch || null);
    }
  }, [setValue]);

  // UPDATE API
  const { mutate: updateApi, isLoading: putLoading } = useMutation(
    async (postData) => {
      try {
        const response = await axios.put(
          `${process.env.REACT_APP_HOST}/companies/${companyDetails?.id}`,
          postData
        );
        return response.data;
      } catch (error) {
        console.error("Error updating quotation:", error);
        throw error; // re-throw to trigger onError
      }
    },
    {
      onSuccess: () => {
        alert("Profile Updated Successfully..");
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      },
      onError: (error) => {
        console.error("Mutation failed:", error);
        alert("Failed to update the profile. Please try again.");
      },
    }
  );

  const onSubmit = (data) => {
    let formData = {
      id: data?.id || null,
      customerName: data?.customerName || null,
      shopName: data?.shopName || null,
      customerPhno: data?.customerPhno || null,
      customeralternativePhno: data?.customeralternativePhno || null,
      companyAddress: data?.companyAddress || null,
      companyLogo: data?.companyLogo || null,
      companyLocation: data?.companyLocation || null,
      companyPincode: data?.companyPincode || null,
      companyType: data?.companyType || null,
      emailId: data?.emailId || null,
      website: data?.website || null,
      gstNumber: data?.gstNumber || null,
      role: data?.role || null,
      password: data?.password || null,
      confirmpassword: data?.confirmpassword || null,
      gstNo: data?.gstNo || null,
      customerLevel: data?.customerLevel || null,
      lineRoute: data?.lineRoute || null,
      phoneNumber: data?.phoneNumber || null,
      status: data?.status || null,
      headoffice: data?.headoffice || null,
      district: data?.district || null,
      aCHolderName: data?.aCHolderName || null,
      bankName: data?.bankName || null,
      accountNumber: data?.accountNumber || null,
      ifscCode: data?.ifscCode || null,
      branch: data?.branch || null,
    };
    if (formData) {
      updateApi(formData);
    }
  };
  return (
    <>
      <div className="form_main_block">
        <div className="form_sub_block">
          <form className="p-4" onSubmit={handleSubmit(onSubmit)}>
            <div className="row px-3">
              <div className="col-12 col-md-4 d-flex flex-column gap-2 mb-3">
                <label className="executive_label">Name</label>
                <Controller
                  name="customerName"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      {...field}
                      type="text"
                      placeholder="Name"
                      className="profile_input_field"
                    />
                  )}
                />
              </div>

              <div className="col-12 col-md-4 d-flex flex-column gap-2 mb-3">
                <label className="executive_label">Phone Number</label>
                <Controller
                  name="customerPhno"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      {...field}
                      type="tel"
                      placeholder="Phone Number"
                      className="profile_input_field"
                    />
                  )}
                />
              </div>
              <div className="col-12 col-md-4 d-flex flex-column gap-2 mb-3">
                <label className="executive_label">Alt Number</label>
                <Controller
                  name="customeralternativePhno"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      {...field}
                      type="tel"
                      placeholder="Alt Number"
                      className="profile_input_field"
                    />
                  )}
                />
              </div>
            </div>
            <div className="row px-3">
              <div className="col-12 col-md-4 d-flex flex-column gap-2 mb-3">
                <label className="executive_label">Company Name</label>
                <Controller
                  name="shopName"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      {...field}
                      type="text"
                      placeholder="Company Name"
                      className="profile_input_field"
                    />
                  )}
                />
              </div>

              <div className="col-12 col-md-4 d-flex flex-column gap-2 mb-3">
                <label className="executive_label">Company Address</label>
                <Controller
                  name="companyAddress"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      {...field}
                      type="tel"
                      placeholder="Company Address"
                      className="profile_input_field"
                    />
                  )}
                />
              </div>
              <div className="col-12 col-md-4 d-flex flex-column gap-2 mb-3">
                <label className="executive_label">Company Pincode</label>
                <Controller
                  name="companyPincode"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      {...field}
                      type="text"
                      placeholder="Pincode"
                      className="profile_input_field"
                    />
                  )}
                />
              </div>
            </div>
            <div className="row px-3">
              {/* <div className="col-12 col-md-4 d-flex flex-column gap-2 mb-3">
                <label className="executive_label">Company Logo</label>
                <Controller
                  name="companyLogo"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      {...field}
                      type="file"
                      className="profile_input_field"
                    />
                  )}
                />
              </div> */}
              <div className="col-12 col-md-4 d-flex flex-column gap-2 mb-3">
                <label className="executive_label">Website</label>
                <Controller
                  name="website"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      {...field}
                      type="text"
                      placeholder="Website"
                      className="profile_input_field"
                    />
                  )}
                />
              </div>
              <div className="col-12 col-md-4 d-flex flex-column gap-2 mb-3">
                <label className="executive_label">Company Type</label>
                <Controller
                  name="companyType"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      {...field}
                      type="text"
                      placeholder="Company Type"
                      className="profile_input_field"
                    />
                  )}
                />
              </div>
              <div className="col-12 col-md-4 d-flex flex-column gap-2 mb-3">
                <label className="executive_label">GST Number</label>
                <Controller
                  name="gstNumber"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      {...field}
                      type="text"
                      placeholder="Gst Number"
                      className="profile_input_field"
                    />
                  )}
                />
              </div>
            </div>
            <div className="row px-3">
              <div className="col-12 col-md-4 d-flex flex-column gap-2 mb-3">
                <label className="executive_label">Email ID</label>
                <Controller
                  name="emailId"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      {...field}
                      type="email"
                      placeholder="Email"
                      className="profile_input_field"
                    />
                  )}
                />
              </div>
              <div className="col-12 col-md-4 d-flex flex-column gap-2 mb-3">
                <label className="executive_label">New Password</label>
                <Controller
                  name="password"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      {...field}
                      type="password"
                      placeholder="********"
                      className="profile_input_field"
                    />
                  )}
                />
              </div>
              <div className="col-12 col-md-4 d-flex flex-column gap-2 mb-3">
                <label className="executive_label">Confirm Password</label>
                <Controller
                  name="confirmpassword"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      {...field}
                      type="password"
                      placeholder="********"
                      className="profile_input_field"
                    />
                  )}
                />
              </div>
            </div>
            <div className="row px-3">
              <div className="col-12">
                <button className="profile_submit" type="submit">
                  {putLoading ? (
                    <>
                      <i class="fa fa-spinner fa-spin"></i>
                    </>
                  ) : (
                    <>Submit</>
                  )}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default ProfileCom;
